import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import { connectionSequenceStepLogApi } from "./api";

import GetConnectionSequenceStepLogsResponse = App.Http.Responses.ConnectionSequenceStepLog.GetConnectionSequenceStepLogsResponse;
import GetConnectionSequenceStepLogResponse = App.Http.Responses.ConnectionSequenceStepLog.GetConnectionSequenceStepLogResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

// Query to get a list of connection sequence step logs
export const useGetConnectionSequenceStepLogsQuery = (
    request: {
        filter?: App.Http.Requests.FilterRequest;
    },
    options = {}
) => {
    return useQueryApi<GetConnectionSequenceStepLogsResponse>({
        queryKey: ["getConnectionSequenceStepLogs"],
        queryFn: () => connectionSequenceStepLogApi.index(request),
        ...options,
    });
};

// Query to get a specific connection sequence step log
export const useGetConnectionSequenceStepLogQuery = (
    logId: string,
    request: {
        filter?: App.Http.Requests.FilterRequest;
    },
    options = {}
) => {
    return useQueryApi<GetConnectionSequenceStepLogResponse>({
        queryKey: ["getConnectionSequenceStepLog", logId],
        queryFn: () => connectionSequenceStepLogApi.show(logId, request),
        ...options,
    });
};

// Mutation to get conversion states export file
export const useGetConnectionSequenceStepLogsExportMutation = (
    options: UseMutationOptions<ExportResponse, AxiosError<ApiErrorResponse>, BaseExportRequest> = {}
) => {
    return useMutationApi<ExportResponse, BaseExportRequest>({
        mutationKey: ["getConnectionSequenceStepLogsExport"],
        mutationFn: (request) => connectionSequenceStepLogApi.export(request),
        ...options,
    });
};
